import React from 'react';
import Message from '../../../../../components/Message/Message';

const MessageModal = ({ type, children, title, onConfirm, onCancel, onOkay }) => {
    return (
        <Message 
            type={type} 
            children={children} 
            title={title} 
            onConfirm={onConfirm} 
            onCancel={onCancel} 
            onOkay={onOkay} 
        />
    );
};

export default MessageModal;